module.exports = __webpack_public_path__ + "assets/img/familyCrest-8f5e49b4.png";